// extracted by mini-css-extract-plugin
export default {"center":"ModalComponent_center__wXmUL","itemText":"ModalComponent_itemText__r5kiC","textFunction":"ModalComponent_textFunction__qqC56"};